export default [
  //Students
  {
    path: "/s9Tfw7",
    children: [
      {
        path: "/PqVEnm0Ir",
        name: "baice26.students",
        meta: {
          title: "BAICE 2026 students",
          authRequired: true,
          acc: ["y39592"],
        },
        component: () => import("@/views/baice/tws/student/index.vue"),
      },
      {
        path: "/SrigNVLppd",
        name: "create.student.baice26",
        meta: {
          title: "Create BAICE 2026 student",
          authRequired: true,
          acc: [""],
        },
        component: () => import("@/views/baice/tws/student/create.vue"),
      },
      {
        path: "/oOodgAvTEg/:str?",
        name: "baice26.student",
        meta: {
          title: "View BAICE 2026 student",
          authRequired: true,
          acc: ["y79312"],
        },
        component: () => import("@/views/baice/tws/student/view.vue"),
      },
      {
        path: "/a9J7kAP/:str?",
        name: "baice26.studentedit",
        meta: {
          title: "Edit BAICE 2026 student",
          authRequired: true,
          acc: [""],
        },
        component: () => import("@/views/baice/tws/student/edit.vue"),
      },
      {
        path: "/EPmW9susP",
        name: "baice26.studentsanalysis",
        meta: {
          title: "BAICE 2026 students analysis",
          authRequired: true,
          acc: [""],
        },
        component: () => import("@/views/baice/tws/student/analysis.vue"),
      },
      // {
      //   path: "/generate",
      //   name: "generateExamNumber",
      //   meta: {
      //     title: "GENERATE EXAM NUMBER",
      //   },
      //   component: () =>
      //     import("../views/baice/student_management/generateExamNumber.vue"),
      // },
      // {
      //   path: "/export",
      //   name: "exportStudents",
      //   meta: {
      //     title: "EXPORT STUDENTS",
      //   },
      //   component: () =>
      //     import("../views/baice/student_management/exportStudents.vue"),
      // },
    ],
  },
];
